import React from "react";
import { Link as ScrollLink } from "react-scroll";
import Link from "next/link"
import Image from "next/image";
import menu_data from "./MenuData";

const MuseNavMenu = () => {
  return (
    <>
      <ul>
        {menu_data.map((item, index) => (
          <li key={index}>
            {/* <ScrollLink to={item.link}>{item.title}</ScrollLink> */}
            <Link href={item.link}>{item.title}</Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default MuseNavMenu;
